import React from "react";
import { Icon } from "@iconify/react";
import vide1 from "../../../assets/video/updated0102 (1).mp4";
import vide2 from "../../../assets/video/Azure A9032 (online-video-cutter.com).mp4";
import { useNavigate } from "react-router-dom";

export default function ExploreCollection() {
	const navigate = useNavigate();
	const video = {
		src: vide1,
		text: "EXPLORE GOWNS",
		desc: "Discover the elegance and charm of our exclusive collection.",
	};
	const video1 = {
		src: vide2,
		text: "EXPLORE GOWNS",
		desc: "Discover the elegance and charm of our exclusive collection.",
	};

	return (
		<div className="flex flex-col justify-center items-center pb-20 mt-[220px] w-full">
			<div className="grid md:grid-cols-2 grid-cols-1 w-full 2xl:px-28 xl:px-20 md:px-10 px-4 md:gap-5 gap-5">
				{/* Left Image */}
				<div className="relative 2xl:h-[1000px] xl:h-[700px] md:h-[700px] ms:h-[700px] h-[600px] w-full overflow-hidden group ">
					{/* Video Background */}
					<video
						src={video.src}
						autoPlay
						loop
						muted
						playsInline
						className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
					/>

					{/* Content */}
					<div className="absolute inset-0 flex flex-col justify-end items-center text-center p-6">
						<button
							onClick={() => navigate("prom/2026")}
							className="flex items-center justify-center gap-2 px-6 py-3 font-lora text-white text-base font-semibold rounded-full bg-[#2a4ba0]/80 hover:bg-[#1f4c94] transition duration-300 mb-3">
							{video.text}
							<Icon
								icon="flowbite:arrow-right-outline"
								width="1.8rem"
								height="1.8rem"
								className="hidden md:block"
							/>
						</button>
						<p className="text-gray-100 text-sm font-light leading-relaxed max-w-sm">
							{video.desc}
						</p>
					</div>
				</div>

				{/* Center Video Section */}
				<div className="relative 2xl:h-[1000px] xl:h-[700px] md:h-[700px] ms:h-[700px] h-[600px] w-full overflow-hidden group">
					{/* Video Background */}
					<video
						src={video1.src}
						autoPlay
						loop
						muted
						playsInline
						className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
					/>

					{/* Content */}
					<div className="absolute inset-0 flex flex-col justify-end items-center text-center p-6">
						<button
							onClick={() => navigate("/prom/2026")}
							className="flex items-center justify-center gap-2 px-6 py-3 font-lora text-white text-base font-semibold rounded-full bg-[#2a4ba0]/80 hover:bg-[#1f4c94] transition duration-300 mb-3">
							{video1.text}
							<Icon
								icon="flowbite:arrow-right-outline"
								width="1.8rem"
								height="1.8rem"
								className="hidden md:block"
							/>
						</button>
						<p className="text-gray-100 text-sm font-light leading-relaxed max-w-sm">
							{video1.desc}
						</p>
					</div>
				</div>

				{/* Right Image */}
			</div>
		</div>
	);
}
